import { useCallback } from 'react';
import { useBaseTrackUserAnalytics } from './useAnalyticsTrack';

export let errorTrackingOptions = {};

export function useInitializeErrorTracking() {
  const initializeErrorTracking = useCallback((user) => {
    errorTrackingOptions = {
      user,
    };
  }, []);

  return [initializeErrorTracking];
}

export function useErrorTrackUserAnalytics() {
  return useBaseTrackUserAnalytics(errorTrackingOptions);
}
